<script>
import ApiHandler from "@/mixin/ApiHandler";
import FileUploadBox from "@/components/common/FileUploadBox";
import DeleteConfirmDialog from "@/components/common/dialog/DeleteConfirmDialog.vue";

export default {
  name: "FileUploadList",
  components: {
    DeleteConfirmDialog,
    FileUploadBox
  },
  props: {
    maxFileSize: {
      type: Number,
      default: 1024 * 1024 * 20
    },
    baseId: {
      type: Number,
      default: null
    },
    mediaList: {
      type: Array,
      default: () => []
    },
    dispatchType: {
      type: String,
      default: "",
      required: true
    },
    downloadActionName: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      uploadFile: {
        file: "",
        fileName: "",
        fileUrl: "",
        fileSize: null
      },
      fileTitle: "",
      fileId: null,
      loading: {
        upload: false
      }
    };
  },
  computed: {
    getErrors() {
      return this.errors;
    },
    getMaxSizeMBString() {
      return (this.maxFileSize / 1024 / 1024).toFixed(0);
    }
  },
  mixins: [ApiHandler],
  methods: {
    upload() {
      this.errors = {};

      if (this.uploadFile.fileSize > this.maxFileSize) {
        this.errors["uploadFile"] = "ファイルサイズが" + this.getMaxSizeMBString + "MBを超えています";
        return;
      }

      this.loading.upload = true;

      let formData = new FormData();
      if (this.uploadFile.file !== "") {
        formData.append("uploadFile", this.uploadFile.file);
      }

      formData.append("baseId", this.baseId);

      this.$store
        .dispatch(this.dispatchType, formData)
        .then(value => {
          this.$emit("uploaded", value);
          return Promise.resolve(value);
        })
        .catch(error => {
          if (error.response.data["fieldErrors"]) {
            this.errors = error.response.data["fieldErrors"];
          } else {
            this.openErrorMsgBox(error.response.data.message);
          }

          return Promise.reject(error);
        })
        .finally(() => {
          this.loading.upload = false;
        });
    },
    erase() {},
    save() {},
    closeDialog() {
      this.$refs.EditDialog.closeDialog();
    },
    closeDialogCallback() {
      // this.record = this.initData();
    },
    clear() {
      this.$set(this.uploadFile, "file", "");
      this.$set(this.uploadFile, "fileName", "");
      this.$set(this.uploadFile, "fileUrl", "");
      this.$set(this.uploadFile, "fileSize", null);
    },
    deleteConfirm(fileId) {
      this.fileId = fileId;
      this.$refs.DeleteConfirmDialog.openDialog();
    },
    deleteCommit() {
      this.$emit("delete", this.fileId);
      this.fileId = null;
    },
    downloadMedia(mediaId) {
      this.$store.dispatch(this.downloadActionName, mediaId);
    },
    formatYmd(dateTimeString) {
      return window.Common.Util.getFullDateTimeIsoFormat(new Date(Date.parse(dateTimeString)));
    }
  }
};
</script>

<template lang="pug">
  section
    v-layout(row wrap align-baseline)
      v-flex(xs12 md10)
        FileUploadBox(v-bind:selected-file.sync="uploadFile" v-bind:errors="getErrors")
      v-flex(xs6 md2)
        v-btn(color="success" @click="upload" :loading="loading.upload" ) アップロード
      v-flex(xs12)
    v-layout(row wrap align-baseline)
      template(v-for="media in mediaList")
        v-flex(xs6)
          v-btn(color="red" flat icon @click="deleteConfirm(media.id)")
            v-icon(flat icon) close
          span() {{media.displayFileName}}
          v-btn(color="grey" flat icon @click="downloadMedia(media.id)")
            v-icon(flat icon) download
        v-flex(xs4)
          span {{formatYmd(media.updatedAt)}}


    DeleteConfirmDialog(ref="DeleteConfirmDialog" @yes="deleteCommit"
    , title="ファイル削除確認" message="ファイルを削除しますか？")

</template>

<style scoped lang="stylus"></style>
